module.exports = __webpack_public_path__ + "img/icon-finance.8e2a4a2c.svg";